exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.template-task-card{position:relative;border-radius:4px;background-color:#fff;box-shadow:0 1px 3px 0 rgba(0,0,0,.25);width:200px;height:116px;margin-left:15px;margin-bottom:11px;cursor:pointer}.template-task-card.fade-in{opacity:1;animation-name:fadeInOpacity;animation-iteration-count:1;animation-timing-function:ease-in;animation-duration:1s}.template-task-card .pencil-icon{position:absolute;top:6px;right:6px;width:20px;height:20x;border-radius:3px}.template-task-card .pencil-icon img{width:16px;height:16px;margin-top:2px;margin-left:2px}.template-task-card .pencil-icon.hovered-over{background-color:#f0f0f0}@keyframes fadeInOpacity{0%{opacity:0}to{opacity:1}}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ProjectTemplatesContainer/ProjectTemplateTasks/TaskCard/TaskCard.scss
// module id = 1794
// module chunks = 0